import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { color, font, layout } from "../../theme/tokens";

export const Nav = styled.nav`
  background: ${color.paper};
  border-bottom: 1px solid ${color.ruleSoft};
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 20;

  @media screen and (max-width: 800px) {
    height: 68px;
  }
`;

export const NavBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: ${layout.maxWidth};
  height: 100%;
  padding: 0 ${layout.gutter};

  @media screen and (max-width: 800px) {
    padding: 0 ${layout.gutterMobile};
  }
`;

export const NavLogo = styled(LinkR)`
  display: flex;
  align-items: center;
  /* The mark itself is only 30px tall on mobile; pad the link out to a
     comfortable touch target. */
  min-height: 44px;
  cursor: pointer;
  text-decoration: none;
`;

export const MobileIcon = styled.button`
  display: none;

  @media screen and (max-width: 800px) {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    /* 44px minimum touch target. */
    width: 44px;
    height: 44px;
    padding: 0;
    margin-right: -10px;
    font-size: 1.35rem;
    color: ${color.inkStrong};
    cursor: pointer;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 40px;

  @media screen and (max-width: 800px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  display: flex;
  align-items: center;
`;

export const NavLinks = styled(LinkR)`
  font-family: ${font.body};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${color.inkStrong};
  text-decoration: none;
  padding: 4px 0;
  border-bottom: 1px solid transparent;
  transition: color 160ms ease, border-color 160ms ease;

  &:hover,
  &.active {
    color: ${color.green};
    border-bottom-color: ${color.green};
  }
`;
